import React from "react";

export default function C_V_TIME({ value }) {
  if (!value) return null;

  return (
    <span
      title={value}
      style={{
        display: "block",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "100%",
        lineHeight: "1.5",
        padding: "0 8px",
        boxSizing: "border-box",
      }}
    >
      {value}
    </span>
  );
}
